const getGlobalStates = (data) => data.globalState;

export const getAccountDetails = (data) => {
  const { accountdetails_data } = getGlobalStates(data);
  return accountdetails_data
}

export const selectAccountID = (state) => {
  const { accountID } = getGlobalStates(state);
  return accountID;
};

export const selectNavBarData = (state) => {
  const { navBarData } = getGlobalStates(state);
  return navBarData;
};

export const selectCsrBusinessFunction = (state) => {
  const { business_functions } = getGlobalStates(state).csr;
  return business_functions;
};


/**
 * mapData returns codeValueMappingData
 * 
 * @param {object} data 
 */
export const mapData = (data) => {
  const { codeValueMappingData } = getGlobalStates(data);
  return codeValueMappingData;
}

export const titleDropDwonValues = (data) => {
  const { title } = mapData(data);
  return title;
}

export const suffixDropDownValues = (data) => {
  const { suffix } = mapData(data);
  return suffix;
}

export const phoneDropDownValues = (data) => {
  const { phoneAddressTypes } = mapData(data);
  return phoneAddressTypes;
}

export const emailDropDownValues = (data) => {
  const { emaileAddressTypes } = mapData(data);
  return emaileAddressTypes;
}

export const addressDropDownValues = (data) => {
  const { postalAddressTypes } = mapData(data);
  return postalAddressTypes;
}

export const stateDropDownValues = (data) => {
  const { states } = mapData(data);
  return states;
}

export const countryDropDownValues = (data) => {
  const { countries } = mapData(data);
  return countries;
}

export const genderDropDownValues = (data) => {
  const { gender } = mapData(data);
  return gender;
}

export const fetchStepCountNum = (state) => {
  const { activePageStepNumber } = getGlobalStates(state);
  return activePageStepNumber;
};

export const fetchStepperConfig = (state) => {
  const { stepperConfig } = getGlobalStates(state);
  return stepperConfig;
};

export const fetchStepperIndex = (state) => {
  const { stepperUpdateIndex } = getGlobalStates(state);
  return stepperUpdateIndex;
};

export const fetchStepperEdit = (state) => {
  const { stepperEditIndex } = getGlobalStates(state);
  return stepperEditIndex;
};

export const selectAvailableBalance = (state) => {
  const { availableBalance } = getGlobalStates(state);
  return availableBalance;
};

export const selectCurrentBalance = (state) => {
  const { currentBalance } = getGlobalStates(state);
  return currentBalance;
};

export const selectAdvisors = (state) => {
  const { advisors } = getGlobalStates(state);
  return advisors;
};

export const selectApplicableBusinessFunction = (state) => {
    const { csr } = getGlobalStates(state);
    return csr.applicable_business_function;
  };
//fallback Error 


const selectGLobalError = (state)=>{
  return getGlobalStates(state).globalError||{}
}

export const selectfallbackError = (state)=>{
  return selectGLobalError(state).error
}

export const selectisLogout = (state)=>{
  return selectGLobalError(state).isLogout;
}
export const selectprimaryCtaLabel = (state)=>{
  return selectGLobalError(state).primaryCtaLabel;
}
export const selectfallbackMessage = (state)=>{
  return selectGLobalError(state).message;
}
export const selectfallbackTitle = (state)=>{
  return selectGLobalError(state).errtitle;
}
export const selectfallbackRedirect = (state)=>{
  return selectGLobalError(state).redirect;
}
export const selectisDirectlogout = (state)=>{
  return selectGLobalError(state).isDirectlogout;
}
export const selectisRedirectfirst = (state)=>{
  return selectGLobalError(state).isRedirectfirst;
}


//fallback error end 

export const selectActiveStepNumber = (state)=>{
  return getGlobalStates(state).activePageStepNumber
}

export const selectStepConfig = (state)=>{
  return getGlobalStates(state).stepperConfig
}
export const selectStepperUpdateIndex = (state)=>{

  return getGlobalStates(state).stepperUpdateIndex
}
export const selectedHeader = (state) => {
  const { selectedHeader} = getGlobalStates(state);
  return selectedHeader;
}

export const accountStatus = (state) => {
  const { account } = getGlobalStates(state);
  return account;
}

export const navBarData = (state) => {
  const { navBarData } = getGlobalStates(state);
  return navBarData;
}

export const financialAdvisorStatus = (state) => {
  const { accountChangedOnfinacialAdvisor } = getGlobalStates(state);
  return accountChangedOnfinacialAdvisor;
}

export const sessionLoading = (state) => {
  const { isLoading } = getAccountDetails(state);
  return isLoading;
}

export const timerModalCountDown = (state) => {
  const { countDown } = getGlobalStates(state);
  return countDown;
}

export const sessionPopUp = (state) => {
  const { showSessionPopUp } = getGlobalStates(state);
  return showSessionPopUp;
}

export const summaryLoading = (state) => {
  const { summaryIsLoading } = getGlobalStates(state);
  return summaryIsLoading;
}

export const pageSummaryError = (state) => {
  const { error } = getGlobalStates(state);
  return error;
}
export const selectAccountName = (state) => {
    const { accountName } = getGlobalStates(state);
    return accountName;
}
//App.js
export const selectUserSessionLoading = (state)=>{
   const {accountdetails_data:{isLoading} = {}} =  getGlobalStates(state)
   return isLoading 
}
